import { TOKEN, TOKEN_TIME, TOKEN_TIME_VALUE, LOGIN_TYPE } from '@/utils/constant'
import { useStore } from 'vuex'
import { config } from '@/config/config'
const TokenKey = 'token'
// 定义token过期时间key
const timeKey = 'expireTime'
// 登录时设置时间
export const setTokenTime = () => {
  localStorage.setItem(TOKEN_TIME, Date.now() + '')
}
// 设置登录类型
export const setTokenLoginType = (param: any) => {
  localStorage.setItem(LOGIN_TYPE, param)
}

/**
 * 设置token过期时间
 * @param time
 */
export function setTokenExpireTime(time: any) {
  console.log('刷新TOKEN')
  localStorage.setItem(TOKEN_TIME, time)
}

// 获取token时间
export const getTokenTime = () => {
  return localStorage.getItem(TOKEN_TIME)
}
// 获取token
export const getToken = () => {
  return localStorage.getItem(TOKEN)
}
// 移除token
export const removeToken = () => {
  return localStorage.removeItem(TOKEN)
}
// 获取token时间
export const setToken = (vulue: any) => {
  return localStorage.setItem(TOKEN, vulue)
}
/**
 * 清空sessionStorage
 */
export function clearStorage() {
  return sessionStorage.clear()
}

// 是否已经过期
export const diffTokenTime = () => {
  const currentTime = Date.now()
  const tokenTime: any = getTokenTime()
  return currentTime - tokenTime > TOKEN_TIME_VALUE
}
// 获取登录类型 0表示系统内部登录 1表示用户中心认证登录
export const getLoginType = () => {
  return localStorage.getItem('loginType') || '0'
}
// 获取等三方平台刷新凭证
export const getRefreshTokenCode = () => {
  return localStorage.getItem('URefreshToken') || ''
}
// 获取等三方平台Token过期时间 单位是时间戳秒
export const getUExpireTime = () => {
  return localStorage.getItem('UExpireTime')
}
export const hasPermission = (param: any) => {
  const store = useStore()
  // const roles = store.getters.roles
  const roles = JSON.parse(sessionStorage.getItem('codeList') + '')
  if (roles.lastIndexOf(param) === -1) {
    return false
  } else {
    return true
  }
}

// 构建OAuth2.0授权请求URL的函数
export const buildAuthUrl = (appId: string, redirectUrl: string, state = 1234, reLogin = 0) => {
  // 对参数进行URLEncode编码
  const authBaseUrl = config.authBaseUrl
  const encodedRedirectUrl = encodeURIComponent(redirectUrl)
  // 构造查询参数字符串，不对 appId 和可能不需要的 state 进行编码
  const queryParamsString = `appId=${appId}&redirect=${encodedRedirectUrl}&state=${state}&reLogin=${reLogin.toString()}`
  console.log(queryParamsString)
  return `${authBaseUrl}?${queryParamsString}`
}
